import { render, staticRenderFns } from "./CarDocumentPreview.vue?vue&type=template&id=4af8dee5&scoped=true&"
import script from "./CarDocumentPreview.vue?vue&type=script&lang=js&"
export * from "./CarDocumentPreview.vue?vue&type=script&lang=js&"
import style0 from "./CarDocumentPreview.vue?vue&type=style&index=0&id=4af8dee5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af8dee5",
  null
  
)

export default component.exports